import { Component } from "react";
import { AlertTriangle } from "lucide-react";

// Keeps a rendering error inside one card (e.g. a chart tooltip) from blanking the whole page.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error(`[${this.props.name || "section"}]`, error); // eslint-disable-line no-console
  }

  componentDidUpdate(prev) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="rounded-xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-800" data-testid={`${this.props.testId || "section"}-error`}>
        <p className="font-semibold flex items-center gap-1.5"><AlertTriangle className="h-4 w-4" /> {this.props.name || "This section"} could not be displayed.</p>
        <p className="text-xs mt-1 text-rose-700/80">{String(this.state.error?.message || this.state.error)}</p>
        <button type="button" onClick={() => this.setState({ error: null })} className="mt-2 rounded border border-rose-300 bg-white px-2.5 py-1 text-xs font-semibold hover:bg-rose-100" data-testid={`${this.props.testId || "section"}-error-retry`}>Try again</button>
      </div>
    );
  }
}
